import { readPersistedUtm } from '../utmTracking';

// Only campaign metadata and controlled UI values belong in these events.
export function trackOfferEvent(event, details = {}) {
  const landing = document.querySelector('[data-marketing-offer-code]');
  const banner = document.querySelector('[data-offer-banner]');
  if (!landing && !banner) return;

  const selected = document.querySelector('[data-offer-combo]:checked');
  let utm = {};
  try {
    utm = readPersistedUtm();
  } catch {
    // A malformed tracking cookie must not interrupt a successful callback.
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    offer_code: landing?.dataset.marketingOfferCode || banner.dataset.offerCode,
    offer_phase: landing?.dataset.marketingOfferPhase || banner.dataset.offerPhase,
    ...(selected
      ? { offer_combo: selected.value, offer_product: selected.dataset.label }
      : {}),
    utm_source: utm.utm_source || 'direct',
    utm_campaign: utm.utm_campaign || '',
    ...details,
  });
}
